export let DEBUG = false;
export let PREFIX = '[Keyboardly]';
export const setDebug = (bool) => DEBUG = bool;